// extracted by mini-css-extract-plugin
module.exports = {"container":"MyRewards_container__3tUVf"};